import * as React from "react";
import { Button, Grid, Modal as MuiModal, Typography } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";

interface Props {
  open: boolean;
  closeModal: () => void;
  redirectUrl?: string;
  handleConfirm?: any;
}

const UnsavedDataConfirmation: React.FC<Props> = ({
  open,
  closeModal,
  handleConfirm,
  redirectUrl,
}: Props) => {
  const handleConfirmAction = () => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    } else {
      handleConfirm();
    }
  };

  return (
    <MuiModal open={open} className="modal-primary">
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>Unsaved Changes</span>
                <span id="dismiss-button" onClick={closeModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1E1E1E",
                }}
              >
                Are you sure you want to leave this section? There are some
                unsaved changes.
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div onClick={closeModal} className="cancel-link">
                Cancel
              </div>
              <Button
                onClick={handleConfirmAction}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </MuiModal>
  );
};

export default UnsavedDataConfirmation;
